import type { TrackMetricRequestTags } from './trackMetricRequestTags';

export interface TrackMetricRequest {
  name: string;
  tags?: TrackMetricRequestTags;
  type: string;
  value: number;
}
